module.exports = __webpack_public_path__ + "static/media/whisky_hero_mobile.15e6bccb.jpg";